export class UserSearchModel {
  username:string;
  email:string;
  nominativo:string;
  pageNumber: number;
  pageSize: number;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/user/user-search.model.ts